import { useState } from 'react';

const capacityChartTypes = [
    {
        type: 0,
        name: 'Długość mikropala - wciskanie',
    },
    {
        type: 1,
        name: 'Długość mikropala - wyciąganie',
    },
    {
        type: 2,
        name: 'Nośność mikropala - wciskanie',
    },
    {
        type: 3,
        name: 'Nośność mikropala - wyciąganie',
    },
    {
        type: 4,
        name: 'Nośność obliczeniowa żerdzi',
    },
];
const MicropileCompressionCapacityService = () => {
    const [settings, setSettings] = useState({
        showVertical: true,
        showHorizontal: true,
        showLegend: true,
        showValues: false,
        showDescription: true,
        showValue: true,
        rotateDescriptionX: false,
    });
    const [capacityType, setCapacityType] = useState(0);
    const [capacityName, setCapacityName] = useState(
        'Długość mikropala - wciskanie',
    );
    const [chartNames, setChartNames] = useState({
        0: {
            title: 'Długość mikropala wciskanego',
            axisY: 'Długość mikropala [m]',
            axisX: 'Profile geologiczne',
            legend: '- długość mikropala',
        },
        1: {
            title: 'Długość mikropala wyciąganego',
            axisY: 'Długość mikropala [m]',
            axisX: 'Profile geologiczne',
            legend: '- długość mikropala',
        },
        2: {
            title: 'Nośność obliczeniowa mikropala wciskanego',
            axisY: 'Nośność mikropala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność mikropala',
        },
        3: {
            title: 'Nośność obliczeniowa mikropala wyciąganego',
            axisY: 'Nośność mikropala [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność mikropala',
        },
        4: {
            title: 'Nośność obliczeniowa żerdzi',
            axisY: 'Nośność żerdzi [kN]',
            axisX: 'Profile geologiczne',
            legend: '- nośność żerdzi',
        },
    });

    const onChangeChartTitles = (e = {}, type) => {
        if (e.target) {
            const { name, value } = e.target;

            setChartNames((state) => ({
                ...state,
                [type]: {
                    ...state[type],
                    [name]: value,
                },
            }));
        }
    };

    const onToggleChartType = (e) => {
        const currentSelectProject = capacityChartTypes.find(
            (ele) => ele.name === e.target.value,
        );

        if (currentSelectProject) {
            if ([2, 3].includes(currentSelectProject.type)) {
                setSettings((state) => ({ ...state, showValue: true }));
            }
            setCapacityType(currentSelectProject.type);
            setCapacityName(currentSelectProject.name);
        }
    };

    const onChangeSettings = (e) => {
        e.preventDefault();
        e.persist();

        const name = e.currentTarget.getAttribute('name');

        setSettings((state) => ({ ...state, [name]: !state[name] }));
    };

    const micropileCompressionCapacity = {
        state: {
            chartNames,
            capacityType,
            capacityName,
            capacityChartTypes,

            settings,
        },
        onChangeChartTitles,
        onToggleChartType,
        onChangeSettings,
    };

    return {
        micropileCompressionCapacity,
    };
};

export default MicropileCompressionCapacityService;
